import React, { Component } from 'react';
import Slider from 'react-slick';
import classnames from 'classnames';

import Arrow from './arrow';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings = {
  infinite: false,
  lazyLoad: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
}

function getImageUrl(namespace, name) {
  return `/images/works/${namespace}/${name}.jpg`
}

class Gallery extends Component {
  handleOnZoomChange = (item) => {
    this.props.onZoomChange(item)
  }

  renderZoomBtn(item) {
    if (!item.zoom) {
      return false;
    }

    return (
      <a
        className="gallery__item-zoom"
        onClick={() => this.handleOnZoomChange(item)}
      >
        <i className="icon icon--zoom"></i>
      </a>
    )
  }

  renderDownloadBtn(item) {
    const { namespace } = this.props;
    let href = getImageUrl(namespace, item.file);

    return (
      <a
        className="gallery__item-download"
        download
        href={href}
      >
        <i className="icon icon--download"></i>
      </a>
    )
  }

  render() {
    const { data, namespace } = this.props;

    if (!data.length) {
      return null;
    }

    const items = data.map((item) => {
      let src = getImageUrl(namespace, item.file);

      if (item.zoomActive) {
        src = getImageUrl(namespace, `${item.file}_d`);
      }

      const style = {
        backgroundImage: `url(${src})`,
      }

      const cx = classnames("gallery__item", {"is-zoomed": item.zoomActive})

      return (
        <div key={item.file} className={cx} style={style}>
          <div className="gallery__item-caption">
            { item.name }
          </div>
          { this.renderDownloadBtn(item) }
          { this.renderZoomBtn(item) }
        </div>
      )
    });

    return (
      <Slider
        ref={(c) => this.slider = c }
        className="gallery__slick"
        prevArrow={<Arrow type="prev" />}
        nextArrow={<Arrow type="next" />}
        initialSlide={0}
        {...settings}
      >
        { items }
      </Slider>
    )
  }
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/index.js